import { render, staticRenderFns } from "./WattList.vue?vue&type=template&id=6a2bf12e&scoped=true"
import script from "./WattList.vue?vue&type=script&lang=js"
export * from "./WattList.vue?vue&type=script&lang=js"
import style0 from "./WattList.vue?vue&type=style&index=0&id=6a2bf12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2bf12e",
  null
  
)

export default component.exports